import React from 'react';
import { Alert } from '@edgebox/react-components';

export function FunctionHelp(props: { name?: string; description?: string }) {
  if (!props.name) return null;

  return (
    <Alert variant="light" className="mt-2 mb-0">
      <div className="fw-bold">{props.name}</div>
      <div className="small text-muted">{props.description ?? 'No description available.'}</div>
    </Alert>
  );
}
